import { SET_SOLD_STATUS, SET_ARCHIVE_STATUS, SET_JOB_STATUS, SET_PROJECT_TOKEN } from './constants';

const defaultState = {
    soldStatus: false,
    archiveStatus: false,
    jobStatus: 'lead',
    projectToken: '',
};

const projectstatus = (state = defaultState, action) => {
    switch (action.type) {
        case SET_SOLD_STATUS:
            return { ...state, soldStatus: action.soldStatus };

        case SET_ARCHIVE_STATUS:
            return { ...state, archiveStatus: action.archiveStatus };

        case SET_JOB_STATUS:
            return { ...state, jobStatus: action.jobStatus };

        case SET_PROJECT_TOKEN:
            return { ...state, projectToken: action.projectToken };

        default:
            return state;
    }
};

export default projectstatus;



// WEBPACK FOOTER //
// ./src/containers/common/projectstatus/reducer.js